import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ReactComponent as PersonalCenter } from '@/views/account/assets/icons/personal-center.svg';
import { ReactComponent as PersonalCenterBrand } from '@/views/account/assets/icons/personal-center-brand.svg';
import { ReactComponent as AllTools } from '@/views/account/assets/icons/all-tools.svg';
import { ReactComponent as AllToolsBrand } from '@/views/account/assets/icons/all-tools-brand.svg';
import { ReactComponent as FileIcon } from '@/views/account/assets/icons/file-icon.svg';
import { ReactComponent as FileIconBrand } from '@/views/account/assets/icons/file-icon-brand.svg';
import { ReactComponent as Subscription } from '@/views/account/assets/icons/subscription.svg';
import { ReactComponent as SubscriptionBrand } from '@/views/account/assets/icons/subscription-brand.svg';
import AvatarIcon from '@/assets/images/avatar_person.png';
import AvatarVIPIcon from '@/assets/images/avatar_vip.png';
import withRouter from '../../../../../components/withRouter/withRouter';
import { Divider } from 'antd';
const PersonalCenterLeftRender = ({ headerUrl, location }) => {
  const { t } = useTranslation(['upgradePersonal']);
  const reducerData = useSelector((state) => state.account);
  let isVIP;
  if (reducerData.subscription?.length) {
    let proVip = reducerData.subscription.filter(
      (item) => item.status == 'Active'
    );
    isVIP = proVip.length > 0;
  } else {
    isVIP = false;
  }
  return (
    <>
      <div className='nav-bar'>
        <div className='userAvatar'>
          <div className='userImg'>
            {isVIP ? (
              <img src={AvatarVIPIcon} className='userAvatar' alt='avatar' />
            ) : (
              <img src={AvatarIcon} alt='avatar' className='userAvatar' />
            )}
          </div>
          <div>
            <div className='nickName'>
              {reducerData.profileObj?.nickname || 'Anonymous'}
            </div>
            <div className='userEmail'>{reducerData.profileObj?.email}</div>
          </div>
        </div>
        <Divider />
        <NavLink
          to={`./profile?${headerUrl}`}
          className='menuList px-md-4 px-3'
        >
          {location.pathname === '/personal-center/profile' ? (
            <AllToolsBrand className='menuListIcon' />
          ) : (
            <AllTools className='menuListIcon' />
          )}
          {t('Tools')}
        </NavLink>
        <NavLink
          to={`./history?${headerUrl}`}
          className='menuList  px-md-4 px-3'
        >
          {location.pathname === '/personal-center/history' ? (
            <FileIconBrand className='menuListIcon' />
          ) : (
            <FileIcon className='menuListIcon' />
          )}
          {t('MyProjects')}
        </NavLink>
        <NavLink
          to={`./setting?${headerUrl}`}
          className='menuList px-md-4 px-3'
        >
          {location.pathname === '/personal-center/setting' ? (
            <SubscriptionBrand className='menuListIcon' />
          ) : (
            <Subscription className='menuListIcon' />
          )}
          {t('Subscription')}
        </NavLink>
        <NavLink
          to={`./promotion?${headerUrl}`}
          className='menuList px-md-4 px-3'
        >
          {location.pathname === '/personal-center/promotion' ? (
            <PersonalCenterBrand className='menuListIcon' />
          ) : (
            <PersonalCenter className='menuListIcon' />
          )}
          {t('MyAccount')}
        </NavLink>
      </div>
    </>
  );
};

export default withRouter(PersonalCenterLeftRender);
